import React, { lazy, Suspense } from "react";

import { StyledHomePageContactWrapper } from "./styledHomePageContact";
import { StyledHomePageSectionBlock, StyledMainTitleHomePage } from "../styledHomePage";
import { motion } from "framer-motion";
import { HookResponsive } from "../../elements/customHooks/HookResponsive";

const ContactForm = lazy(() => import("./ContactForm"));

const HomePageContact = () => {

  const textAnimation = {
    hidden: {
      x: -50,
      opacity: 0
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: { delay: 0.2 }
    }
  };

  const contactFormAnimation = {
    hidden: {
      y: -50,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 200, damping: 10, delay: 0.4 }
    }
  };

  return (
    <StyledHomePageContactWrapper
      id="contact"
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <StyledHomePageSectionBlock>
        <motion.div
          variants={HookResponsive() ? textAnimation : null}
        >
          <StyledMainTitleHomePage
            className="contact-title"
            position="center"
            as="h5"
            mb="60"
            size="60"
            lineHeight="26"
            weight="700"
          >
            Try <span>Text me chat</span> now
          </StyledMainTitleHomePage>
        </motion.div>
        <Suspense fallback={<div></div>}>
          <ContactForm
            variants={HookResponsive() ? contactFormAnimation : null}
          />
        </Suspense>
      </StyledHomePageSectionBlock>
    </StyledHomePageContactWrapper>
  );
};

export default HomePageContact;